/* eslint-disable no-console */

export const sendMessage = async (awsConnectContactId, content, attachments) => {
  try {
    const formData = new FormData();
    formData.append('aws_connect_contact_id', awsConnectContactId);
    if (content) formData.append('content', content);
    attachments.forEach((file) => formData.append('attachments[]', file));

    const res = await fetch('/ai/chatkit_messages', {
      method: 'POST',
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content },
      body: formData
    });
    return res.ok;
  } catch (error) {
    console.error('Error sending AWS Connect message:', error);
    return false;
  }
};
